<template>
  <!-- Conteúdo de um card do Carousel (o <swiper-slide class="item"> fica no
       Carousel). Mesmas proporções do card de aula — poster, faixa de 4px,
       nome e rodapé — com preço e "Comprar" no lugar do progresso. -->
  <div class="recommendation-card">
    <div class="recommendation-poster">
      <img :src="imageSrc" class="poster" alt @error="onImageError" />
      <span class="recommendation-tag" :style="{ background: $theme.primaryColor }">
        <i class="material-icons">local_offer</i>Recomendado
      </span>
      <div class="recommendation-poster-caption">{{ headline }}</div>
    </div>
    <div class="recommendation-stripe" :style="{ background: $theme.primaryColor }"></div>

    <div class="item-info">
      <div class="item-name recommendation-title"
        :class="product.description ? 'line-clamp-1' : 'line-clamp-2'"
        :style="{ color: $theme.primaryColor }">
        {{ product.title }}
      </div>
      <div v-if="product.description" class="recommendation-description line-clamp-2"
        :style="$theme.darkTheme ? '' : 'color: #707070'">
        {{ product.description }}
      </div>
    </div>

    <div class="item-footer">
      <div class="flex-between flex-v-center">
        <div class="recommendation-prices">
          <span v-if="hasDiscount" class="recommendation-full-price"
            :style="$theme.darkTheme ? '' : 'color: #A0A0A0'">De {{ originalPriceLabel }}</span>
          <span class="recommendation-promo-price" :style="{ color: $theme.primaryColor }">
            {{ salePriceLabel }}
          </span>
        </div>
        <a href="javascript:;" class="recommendation-cta"
          :style="{ background: $theme.primaryColor }" @click.prevent.stop="onBuy">
          Comprar
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import recommendationMixin from './recommendationMixin'

export default {
  name: 'RecommendationCard',
  mixins: [recommendationMixin]
}
</script>

<style scoped lang="scss">
.recommendation-card {
  height: 100%;
}

.recommendation-poster {
  position: relative;
  height: 118px;
  overflow: hidden;

  // `img.poster` herda tamanho/object-fit de _nextContent.scss
  .poster {
    display: block;
  }
}

.recommendation-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  height: 18px;
  padding: 0 7px;
  border-radius: 9px;
  font-family: roboto;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  color: #fff;

  .material-icons {
    font-size: 12px;
    margin-right: 3px;
  }
}

.recommendation-poster-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 18px 10px 6px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0));
  font-family: roboto;
  font-size: 10px;
  font-weight: 500;
  line-height: 1.25;
  color: #fff;
}

.recommendation-stripe {
  height: 4px;
}

.recommendation-description {
  margin-top: 4px;
  font-family: roboto;
  font-size: 10px;
  line-height: 1.3;
  color: #ffffff99;
}

.recommendation-prices {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.recommendation-full-price {
  font-size: 10px;
  text-decoration: line-through;
  color: #ffffff99;
}

.recommendation-promo-price {
  font-size: 16px;
  font-weight: 800;
}

.recommendation-cta {
  display: inline-flex;
  align-items: center;
  height: 30px;
  padding: 0 14px;
  border-radius: 15px;
  font-family: roboto;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
}
</style>
